import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export interface TermsData {
  id: number | string;
  title: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface TermsApiResponse {
  success: boolean;
  data: TermsData;
}

export const termsApi = {
  getStaticPages: async (id: string | number): Promise<TermsApiResponse> => {
    try {
      const { data } = await axiosClient.get<TermsApiResponse>(
        API_ENDPOINTS.STATIC_PAGES.TERMS(id)
      );
      return data;
    } catch (error) {
      console.error('Error fetching terms:', error);
      throw error;
    }
  },
};
